import { render } from "./PropReservationDetails.vue?vue&type=template&id=31725df2"
import script from "./PropReservationDetails.vue?vue&type=script&lang=js"
export * from "./PropReservationDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__